import { createAsyncAction } from "../utils"
import { api as externalApi } from "../../services/api"
import types from "./types"

const api = externalApi()

export const fetchSubscribed = createAsyncAction(types.GET, api.newsletter.getSubscribed)
export const subscribeNewsletter = createAsyncAction(
  types.SUBSCRIBE,
  api.newsletter.subscribeNewsletter
)
export const unsubscribeNewsletter = createAsyncAction(
  types.UNSUBSCRIBE,
  api.newsletter.unsubscribeNewsletter
)
